import { createContext, useContext, useState } from 'react'

const SoundPermissionContext = createContext()

export const SoundPermissionProvider = ({ children }) => {
    const [isSoundAllowed, setIsSoundAllowed] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(true)

    const allowSound = () => {
        setIsSoundAllowed(true)
        setIsModalOpen(false)
    }

    const value = {
        isSoundAllowed,
        isModalOpen,
        allowSound,
    }

    return (
        <SoundPermissionContext.Provider value={value}>
            {children}
        </SoundPermissionContext.Provider>
    )
}

export const useSoundPermission = () => useContext(SoundPermissionContext)
